





















































































































































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class MobileMech extends Vue {
  /* TODO: Move data to service */
  private data() {
    return {
      mobileAssets: {
        sectionA: {
          neckA: {
            url: require('../assets/home-mech/mobile/mobile-neck-1_26x418.png'),
            alt: 'mobile neck 1',
          },
          elbowA: {
            url: require('../assets/home-mech/mobile/mobile-elbow-1_52x68.png'),
            alt: 'mobile elbow 1',
          },
          neckB: {
            url: require('../assets/home-mech/mobile/mobile-neck-2_156x18.png'),
            alt: 'mobile neck 2',
          },
          elbowB: {
            url: require('../assets/home-mech/mobile/mobile-elbow-2_70x52.png'),
            alt: 'mobile elbow 2',
          },
          neckC: {
            url: require('../assets/home-mech/mobile/mobile-neck-3_18x156.png'),
            alt: 'mobile neck 3',
          },
          elbowC: {
            url: require('../assets/home-mech/mobile/mobile-elbow-3_52x72.png'),
            alt: 'mobile elbow 3',
          },
          elbowD: {
            url: require('../assets/home-mech/mobile/mobile-elbow-4_106x54.png'),
            alt: 'mobile elbow 4',
          },
          valveA: {
            url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
            alt: 'mobile valve 1',
          },
          elbowE: {
            url: require('../assets/home-mech/mobile/mobile-elbow-5_74x50.png'),
            alt: 'mobile elbow 5',
          },
          elbowF: {
            url: require('../assets/home-mech/mobile/mobile-elbow-6_68x52.png'),
            alt: 'mobile elbow 6',
          },
          neckD: {
            url: require('../assets/home-mech/mobile/mobile-neck-4_18x196.png'),
            alt: 'mobile neck 4',
          },
          elbowG: {
            url: require('../assets/home-mech/mobile/mobile-elbow-7_52x68.png'),
            alt: 'mobile elbow 7',
          },
          neckE: {
            url: require('../assets/home-mech/mobile/mobile-neck-5_176x18.png'),
            alt: 'mobile neck 5',
          },
          elbowH: {
            url: require('../assets/home-mech/mobile/mobile-elbow-8_70x52.png'),
            alt: 'mobile elbow 8',
          },
          neckF: {
            url: require('../assets/home-mech/mobile/mobile-neck-6_18x156.png'),
            alt: 'mobile neck 6',
          },
          elbowI: {
            url: require('../assets/home-mech/mobile/mobile-elbow-9_52x72.png'),
            alt: 'mobile elbow 9',
          },
          neckG: {
            url: require('../assets/home-mech/mobile/mobile-neck-7_146x18.png'),
            alt: 'mobile neck 7',
          },
          elbowJ: {
            url: require('../assets/home-mech/mobile/mobile-elbow-10_68x62.png'),
            alt: 'mobile elbow 10',
          },
          neckH: {
            url: require('../assets/home-mech/mobile/mobile-neck-8_18x214.png'),
            alt: 'mobile neck 8',
          },
        },
        sectionB: {
          neckA: {
            url: require('../assets/home-mech/mobile/mobile-neck-9_26x550.png'),
            alt: 'mobile neck 9',
          },
          elbowA: {
            url: require('../assets/home-mech/mobile/mobile-elbow-11_52x70.png'),
            alt: 'mobile elbow 11',
          },
          neckB: {
            url: require('../assets/home-mech/mobile/mobile-neck-10_108x18.png'),
            alt: 'mobile neck 10',
          },
          elbowB: {
            url: require('../assets/home-mech/mobile/mobile-elbow-12_68x52.png'),
            alt: 'mobile elbow 12',
          },
          neckC: {
            url: require('../assets/home-mech/mobile/mobile-neck-11_18x214.png'),
            alt: 'mobile neck 11',
          },
          valveA: {
            url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
            alt: 'mobile valve 1',
          },
          neckD: {
            url: require('../assets/home-mech/mobile/mobile-neck-12_18x214.png'),
            alt: 'mobile neck 12',
          },
          elbowC: {
            url: require('../assets/home-mech/mobile/mobile-elbow-13_52x68.png'),
            alt: 'mobile elbow 13',
          },
          neckE: {
            url: require('../assets/home-mech/mobile/mobile-neck-13_118x18.png'),
            alt: 'mobile neck 13',
          },
          elbowD: {
            url: require('../assets/home-mech/mobile/mobile-elbow-14_70x52.png'),
            alt: 'mobile elbow 14',
          },
          neckF: {
            url: require('../assets/home-mech/mobile/mobile-neck-14_24x414.png'),
            alt: 'mobile neck 14',
          },
        },
        sectionC: {
          neckA: {
            url: require('../assets/home-mech/mobile/mobile-neck-15_24x585.png'),
            alt: 'mobile neck 15',
          },
          elbowA: {
            url: require('../assets/home-mech/mobile/mobile-elbow-15_52x68.png'),
            alt: 'mobile elbow 15',
          },
          neckB: {
            url: require('../assets/home-mech/mobile/mobile-neck-16_156x18.png'),
            alt: 'mobile neck 16',
          },
          elbowB: {
            url: require('../assets/home-mech/mobile/mobile-elbow-16_70x52.png'),
            alt: 'mobile elbow 16',
          },
          neckC: {
            url: require('../assets/home-mech/mobile/mobile-neck-17_18x78.png'),
            alt: 'mobile neck 17',
          },
          valveA: {
            url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
            alt: 'mobile valve 1',
          },
          neckD: {
            url: require('../assets/home-mech/mobile/mobile-neck-18_18x40.png'),
            alt: 'mobile neck 18',
          },
          elbowC: {
            url: require('../assets/home-mech/mobile/mobile-elbow-17_52x71.png'),
            alt: 'mobile elbow 17',
          },
          neckE: {
            url: require('../assets/home-mech/mobile/mobile-neck-19_98x18.png'),
            alt: 'mobile neck 19',
          },
          elbowD: {
            url: require('../assets/home-mech/mobile/mobile-elbow-18_68x52.png'),
            alt: 'mobile elbow 18',
          },
          neckF: {
            url: require('../assets/home-mech/mobile/mobile-neck-20_18x78.png'),
            alt: 'mobile neck 20',
          },
          elbowE: {
            url: require('../assets/home-mech/mobile/mobile-elbow-19_109x68.png'),
            alt: 'mobile elbow 19',
          },
          elbowF: {
            url: require('../assets/home-mech/mobile/mobile-elbow-20_70x62.png'),
            alt: 'mobile elbow 20',
          },
          elbowG: {
            url: require('../assets/home-mech/mobile/mobile-elbow-21_168x60.png'),
            alt: 'mobile elbow 21',
          },
          elbowH: {
            url: require('../assets/home-mech/mobile/mobile-elbow-22_68x52.png'),
            alt: 'mobile elbow 22',
          },
          neckG: {
            url: require('../assets/home-mech/mobile/mobile-neck-21_24x260.png'),
            alt: 'mobile neck 21',
          },
        },
      },
    };
  }
}
